"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordSpanError = exports.endSpanWithDurationFromMilliseconds = void 0;
const api_1 = require("@opentelemetry/api");
function endSpanWithDurationFromMilliseconds(span, timeInMilliseconds) {
    if (!span) {
        return;
    }
    const spanBase = span;
    if (spanBase && spanBase.startTime && spanBase.end) {
        spanBase.end([
            spanBase.startTime[0],
            spanBase.startTime[1] + timeInMilliseconds * 1000000, // nanoseconds
        ]);
    }
}
exports.endSpanWithDurationFromMilliseconds = endSpanWithDurationFromMilliseconds;
function recordSpanError(span, e) {
    if (!span) {
        return;
    }
    if (e.stack) {
        span.setAttribute('error.stack', e.stack);
    }
    span.setAttribute('error.type', e.name);
    span.setAttribute('error.message', e.message);
    span.setStatus({ code: api_1.SpanStatusCode.ERROR });
}
exports.recordSpanError = recordSpanError;
